import { Link } from 'react-router-dom'

import { routes } from '@/shared/config'
import { Button } from '@/shared/ui'

type SuperAdminTabNavProps = {
  activeTab: 'logs' | 'migration' | 'users'
}

const tabs = [
  { id: 'logs' as const, label: 'Logs', href: routes.superAdminLogs },
  { id: 'users' as const, label: 'Users', href: routes.superAdminUsers },
  {
    id: 'migration' as const,
    label: 'Bubble Migration',
    href: routes.superAdminBubbleMigration,
  },
]

export function SuperAdminTabNav({ activeTab }: SuperAdminTabNavProps) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {tabs.map((tab) => (
        <Link key={tab.id} to={tab.href}>
          <Button type="button" variant={activeTab === tab.id ? 'primary' : 'secondaryAssist'}>
            {tab.label}
          </Button>
        </Link>
      ))}
    </div>
  )
}
